module.exports = __webpack_public_path__ + "img/dafushan.b180e624.png";